import dayjs from '@utils/dayjs';
import { DATE_FORMATS } from '@callmart/types';

export const addRowsInMap = ({ strategicVolumes, monthColumns, compareWithCapacityReport }) => {
    let rowsMap = new Map();

    for (const startegicVolume of strategicVolumes) {
        const key = `${startegicVolume.id}`;

        const {
            id: strategicVolumeId,
            forecasterId,
            forecasterNames,
            contact,
            comment,
            workingUnitLocation,
            capacityType,
        } = startegicVolume;

        const reports = {
            strategicVolumeId,
            forecasterId,
            forecasterNames,
            contact,
            comment,
            capacityType: capacityType,
            workingUnitLocationId: workingUnitLocation.id,
            workingUnitId: workingUnitLocation.workingUnit.id,
            worktype: {
                id: workingUnitLocation.workingUnit.worktype.id,
                name: workingUnitLocation.workingUnit.worktype.worktype,
            },
            channel: {
                id: workingUnitLocation.workingUnit.channel.id,
                name: workingUnitLocation.workingUnit.channel.name,
            },
            task: {
                id: workingUnitLocation.workingUnit.task.id,
                name: workingUnitLocation.workingUnit.task.name,
            },
            selected: false,
        };

        monthColumns.forEach((monthColumn) => {
            const month = dayjs(monthColumn).format(DATE_FORMATS.YEAR_MONTH);

            const strategicVolumeReport = startegicVolume.strategicVolumeReports.find(
                (cr) => dayjs(new Date(cr.date)).format(DATE_FORMATS.YEAR_MONTH) === month
            );
            const strategicVolumeReportValue = strategicVolumeReport ? strategicVolumeReport.value : null;
            reports[month] = {
                value: strategicVolumeReportValue,
                originalValue: strategicVolumeReportValue,
                strategicVolumeReportId: strategicVolumeReport?.id,
                release: strategicVolumeReport?.release,
            };

            if (compareWithCapacityReport) {
                const capacityReport =
                    startegicVolume.matchingCapacity &&
                    startegicVolume.matchingCapacity.capacityReports.find((cr) => {
                        let result = dayjs(new Date(cr.date)).format(DATE_FORMATS.YEAR_MONTH) === month;
                        return result;
                    });

                const capacityReportValue = capacityReport ? capacityReport.value : 0;

                reports[`${month}`] = {
                    ...reports[`${month}`],
                    capacityReportValue,
                    capacityReport,
                    ...((strategicVolumeReportValue || capacityReportValue) && {
                        differenceWithCapacity: strategicVolumeReportValue - capacityReportValue,
                    }),
                };
            }
        });

        if (rowsMap.has(key)) {
            rowsMap.set(key, {
                ...rowsMap.get(key),
                ...reports,
            });
        } else {
            rowsMap.set(key, {
                ...reports,
            });
        }
    }

    return rowsMap;
};
